import { useEffect, useRef, useState, type RefObject } from 'react';

/** Track an element's content width so SVG panes fill their container. */
export const useElementWidth = <T extends HTMLElement>(): [
  RefObject<T>,
  number,
] => {
  const ref = useRef<T>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver((entries) => {
      const next = Math.round(entries[0].contentRect.width);
      setWidth((previous) => (previous === next ? previous : next));
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return [ref, width];
};
